export default __webpack_public_path__ + "static/media/no-profile-img.9dc92b0a.png";